<div class="field">
  <span class="field__label">Offer type</span>
  <pdq-dropdown
    [formControl]="goal.controls.offer.controls.type"
    [options]="offerTypeOptions"
    fullWidth="true"></pdq-dropdown>
</div>

@if (goal.controls.offer.controls.type.value === 'orderDiscount') {
  <div class="discount-row" [formGroup]="goal.controls.offer.controls.orderDiscount">
    <div class="field discount-row__type">
      <span class="field__label">Discount type</span>
      <pdq-dropdown
        [formControl]="goal.controls.offer.controls.orderDiscount.controls.discountType"
        [options]="discountTypeOptions"
        fullWidth="true"></pdq-dropdown>
    </div>
    <div class="field discount-row__value">
      <span class="field__label">Discount value</span>
      <pdq-input-arrows
        [formControl]="goal.controls.offer.controls.orderDiscount.controls.value"
        [min]="1"
        [max]="
          goal.controls.offer.controls.orderDiscount.controls.discountType.value === 'percentage' ? 100 : undefined
        "
        [precision]="2"
        [symbol]="
          goal.controls.offer.controls.orderDiscount.controls.discountType.value === 'percentage' ? '%' : currencySymbol
        "
        widthSize="fullwidth"></pdq-input-arrows>
    </div>
  </div>

  <div class="field">
    <span class="field__label">Discount Badge</span>
    <pdq-input
      [formControl]="goal.controls.offer.controls.orderDiscount.controls.labelText"
      [placeholder]="discountLabelPlaceholder"></pdq-input>
  </div>

  <pdq-checkbox
    [formControl]="goal.controls.offer.controls.orderDiscount.controls.autoApply"
    label="Auto-apply discount if reached"
    labelSize="small"></pdq-checkbox>
}

@if (goal.controls.offer.controls.type.value === 'product') {
  <div class="gift-mode-section">
    <span class="field-label">Gift mode</span>
    <pdq-radio-group [formControl]="goal.controls.offer.controls.product.controls.giftMode">
      <pdq-radio-button value="single" text="Single gift"></pdq-radio-button>
      <pdq-radio-button
        value="multiple"
        text="Multiple gifts"
        subText="Customer picks from multiple products or variants"></pdq-radio-button>
    </pdq-radio-group>

    @if (goal.controls.offer.controls.product.controls.giftMode.value === 'multiple') {
      <pdq-radio-group
        [formControl]="goal.controls.offer.controls.product.controls.productDisplayType"
        variant="segmented">
        <pdq-radio-button value="list" text="List">
          <pdq-radio-button-before>
            <pdq-icon icon="two-rectangle" size="small"></pdq-icon>
          </pdq-radio-button-before>
        </pdq-radio-button>
        <pdq-radio-button value="compact" text="Compact">
          <pdq-radio-button-before>
            <pdq-icon icon="rectangle" size="small"></pdq-icon>
          </pdq-radio-button-before>
        </pdq-radio-button>
      </pdq-radio-group>
    }
  </div>

  @if (goal.controls.offer.controls.product.controls.giftMode.value === 'multiple') {
    <div class="product-list-section">
      <div class="product-list-section__header">
        <span class="product-list-section__label"
          >Product List ({{ goal.controls.offer.controls.product.controls.products.value.length }})</span
        >
        <button type="button" class="add-products-btn" (click)="onAddProducts()">+ Add Product</button>
      </div>
      <pdq-product-list
        [products]="goal.controls.offer.controls.product.controls.products.value"
        [showSearch]="true"
        [showRemove]="true"
        [showEdit]="false"
        [showExternalLink]="true"
        [showDragHandle]="true"
        [currencySymbol]="currencySymbol"
        searchPlaceholder="Search..."
        emptyMessage="No products added"
        (remove)="onRemoveProduct($event.id)"
        (externalLink)="onExternalLink($event)"
        (reorder)="onReorderProducts($event)"></pdq-product-list>
    </div>
  } @else {
    @if (goal.controls.offer.controls.product.controls.products.value.length > 0) {
      <pdq-product-list
        [products]="goal.controls.offer.controls.product.controls.products.value"
        [showSearch]="false"
        [showRemove]="true"
        [showEdit]="false"
        [showExternalLink]="true"
        [showDragHandle]="false"
        [showPagination]="false"
        [currencySymbol]="currencySymbol"
        emptyMessage="No product added"
        (remove)="onRemoveProduct($event.id)"
        (externalLink)="onExternalLink($event)"></pdq-product-list>
    }
    <button type="button" class="add-products-btn" (click)="onAddProducts()">
      {{ goal.controls.offer.controls.product.controls.products.value.length > 0 ? 'Change Product' : '+ Add Product' }}
    </button>
  }

  <pdq-checkbox
    [formControl]="goal.controls.offer.controls.product.controls.hideIfProductIsInCart"
    label="Hide Offer If The User Already Has This Product In Their Cart"
    labelSize="small"></pdq-checkbox>

  <pdq-checkbox
    [formControl]="goal.controls.offer.controls.product.controls.discountConfiguration.controls.enabled"
    label="Set discount configuration"
    labelSize="small"></pdq-checkbox>
  @if (goal.controls.offer.controls.product.controls.discountConfiguration.controls.enabled.value) {
    <div class="discount-row" [formGroup]="goal.controls.offer.controls.product.controls.discountConfiguration">
      <div class="field discount-row__type">
        <span class="field__label">Type</span>
        <pdq-dropdown
          [formControl]="goal.controls.offer.controls.product.controls.discountConfiguration.controls.discountType"
          [options]="discountTypeOptions"
          fullWidth="true"></pdq-dropdown>
      </div>
      <div class="field discount-row__value">
        <span class="field__label">Value</span>
        <pdq-input-arrows
          [formControl]="goal.controls.offer.controls.product.controls.discountConfiguration.controls.value"
          [min]="1"
          [max]="
            goal.controls.offer.controls.product.controls.discountConfiguration.controls.discountType.value ===
            'percentage'
              ? 100
              : undefined
          "
          [precision]="2"
          [symbol]="
            goal.controls.offer.controls.product.controls.discountConfiguration.controls.discountType.value ===
            'percentage'
              ? '%'
              : currencySymbol
          "
          widthSize="fullwidth"></pdq-input-arrows>
      </div>
    </div>

    <div class="discount-row">
      <div class="field discount-row__label-text">
        <span class="field__label">
          Discount Badge
          <pdq-icon
            icon="more_information"
            size="x-large"
            color="var(--on-surface-light)"
            matTooltip="Shown below the product name in the Smart Cart and in Shopify checkout. Both surfaces show the same badge."
            matTooltipClass="pdq-mat-tooltip"></pdq-icon>
        </span>
        <pdq-input
          [formControl]="goal.controls.offer.controls.product.controls.discountConfiguration.controls.labelText"
          [placeholder]="discountLabelPlaceholder"></pdq-input>
      </div>
      <div class="field discount-row__label-color">
        <span class="field__label">Label color</span>
        <pdq-input-color
          [formControl]="
            goal.controls.offer.controls.product.controls.discountConfiguration.controls.labelColor
          "></pdq-input-color>
      </div>
    </div>
  }
}
